import apiClient from './core/ApiClient'
import { Fund } from 'src/api/Fund';
import { FundStoreRequest } from 'src/api/FundStoreRequest';
import { FundsFindResponse } from 'src/api/FundsFindResponse';
import { FundsListResponse } from 'src/api/FundsListResponse';

const path = '/api/funds';

const listAll = (): Promise<FundsListResponse> => apiClient.get<FundsListResponse>(path);
const find = (id: number): Promise<Fund> => apiClient.get<FundsFindResponse>(`${path}/${id}`).then(r => r.fund);
const fundSourceNames = (): Promise<string[]> => apiClient.get<string[]>(`${path}/sources`);
const add = (entry: Fund): Promise<void> => {
    const payload: FundStoreRequest = {
        fund: entry
    };
    return apiClient.post<FundStoreRequest, void>(path, payload);
}
const update = (entry: Fund): Promise<void> => {
    const payload: FundStoreRequest = {
        fund: entry
    };
    return apiClient.put<FundStoreRequest, void>(path, payload);
}
const remove = (id: number): Promise<void> => apiClient.delete<void>(`${path}/${id}`);

export const fundService = {
    listAll,
    find,
    fundSourceNames,
    add,
    update,
    remove,
}
